import { twMerge } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';
import Chevron from 'assets/icons/chevron-sharp.svg?react';

export default function MobileCalculatorChevron({
  onClick,
  active,
}: {
  onClick: () => void;
  active: boolean;
}) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      data-test="calculator-mobile-edit"
      onClick={onClick}
      className="lg:hidden w-10 h-10 flex justify-center items-center"
    >
      <span className="sr-only" data-test="calculator-mobile-edit-text">
        {t('calculator:edit')}
      </span>
      <Chevron
        className={twMerge(
          'h-5 w-5 transition-transform',
          active && 'rotate-180',
        )}
        data-test="calculator-mobile-edit-icon"
      />
    </button>
  );
}
